module.exports = __webpack_public_path__ + "assets/icon-netHeight-net65.f9e48077.svg";